import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.apiUrl; // Base URL from environment.ts

  constructor(private http: HttpClient) { }


  
  apiCall<T>(endpoint: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', body?: any): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;

    switch (method) {
      case 'GET':
        return this.http.get<T>(url, );
      case 'POST':
        return this.http.post<T>(url, body,);
      case 'PUT':
        return this.http.put<T>(url, body);
      case 'DELETE':
        return this.http.delete<T>(url);
      default:
        throw new Error(`Unsupported request method: ${method}`);
    }
  }


  private localStorageKeyRolePermission = 'role_permissions'; // Key for storing in localStorage
  private permissions: any = null;  // Cached permissions


  
  getPermissions(): Observable<any> {

    // Check if permissions are cached in localStorage
    const cachedPermissions = localStorage.getItem(this.localStorageKeyRolePermission);
    if (cachedPermissions) {
      // Return cached permissions from localStorage
      this.permissions = JSON.parse(cachedPermissions);
      return of(this.permissions);
    } else {
      // If permissions are in-memory cached, return them
      return of(this.permissions);
    } 
    
  
  }


}
